module.exports = __webpack_public_path__ + "static/media/depoimento-raquel.41c5ea53.jpeg";